var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 53,
    rx: 9.5,
    fill: "url(#paint0_linear_1013_16973)",
    stroke: "url(#paint1_linear_1013_16973)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 19.9625V17.5H19.5V19.9625L27 25.32L34.5 19.9637V19.9625ZM28.25 27.5V37.5L25.75 40V27.5L18.0475 21.9975C17.7237 21.7663 17.4597 21.4612 17.2775 21.1075C17.0953 20.7537 17.0002 20.3616 17 19.9637V17.5C17 16.837 17.2634 16.2011 17.7322 15.7322C18.2011 15.2634 18.837 15 19.5 15H34.5C35.163 15 35.7989 15.2634 36.2678 15.7322C36.7366 16.2011 37 16.837 37 17.5V19.9625C37 20.3606 36.905 20.753 36.7228 21.1069C36.5406 21.4609 36.2765 21.7662 35.9525 21.9975L28.25 27.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1013_16973",
    x1: 5.8746e-7,
    y1: 3.85712,
    x2: 55.0932,
    y2: 5.29254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1013_16973",
    x1: 5.8746e-7,
    y1: 3.85712,
    x2: 55.0932,
    y2: 5.29254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.c69503576be7e9b6816aaa39d5802d9e.svg";
export { ForwardRef as ReactComponent };